import { render, staticRenderFns } from "./modal-busca-selecao.vue?vue&type=template&id=2ce7d60a&scoped=true"
import script from "./modal-busca-selecao.vue?vue&type=script&lang=ts"
export * from "./modal-busca-selecao.vue?vue&type=script&lang=ts"
import style0 from "./modal-busca-selecao.vue?vue&type=style&index=0&id=2ce7d60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7d60a",
  null
  
)

export default component.exports